import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from '../Services/api.service';
import { AuthService } from '../Services/auth.service';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CommonModule } from '@angular/common';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AddCatalogComponent } from "./add-catalog/add-catalog.component";
import { cloneDeep } from 'lodash';
import { FormsModule } from '@angular/forms';
import { SpinnerComponent } from "../Common/Components/spinner/spinner.component";
import { BreadcrumbComponent } from '../Common/Components/breadcrumb/breadcrumb.component';
import { AppComponent } from '../app.component';
import { ConfirmPopupComponent } from './../Common/Components/confirm-popup/confirm-popup.component';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzUploadChangeParam, NzUploadFile, NzUploadModule } from 'ng-zorro-antd/upload';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzTooltipDirective } from "ng-zorro-antd/tooltip";
import { timer, of } from 'rxjs';
import { switchMap, delay, takeWhile, catchError } from 'rxjs/operators';

@Component({
  selector: 'app-catalog-content-management',
  standalone: true,
  imports: [CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, RouterModule, NzLayoutModule, NzMenuModule, NzIconModule, CommonModule, NzAvatarModule,
    NzInputModule, NzButtonModule, NzListModule, NzDropDownModule, NzUploadModule, NzSpaceModule, CdkVirtualForOf, NzDrawerModule, AddCatalogComponent, RouterLink,
    FormsModule, SpinnerComponent, ConfirmPopupComponent, NzModalModule, NzSelectModule, NzTooltipDirective],
  templateUrl: './catalog-content-management.component.html',
  styleUrl: './catalog-content-management.component.scss'
})
export class CatalogContentManagementComponent {
  catalogData: any;
  originalCatalogData: any;
  originalCatalogDBData: any;
  oldCatalogData: any;
  displayCatalogData: any = [];
  addCatalogVisible: boolean = false;
  dataLoaded: boolean = false;
  sortDirAsc: boolean = true;
  searchText: string = '';
  activeTab: string = 'Active';
  groupedHeaderList: any = [];
  showModal: boolean = false;
  showMigrateModal: boolean = false;
  showImportModal: boolean = false;
  showDeleteModal: boolean = false;
  modalMessage: string = '';
  modalButton: string = '';
  selectedCatalogId: any = '';
  selectedCatalog: any = '';
  selectedOldCatalogId: any = '';
  breadcrumbs: Array<{ label: string, url: any }> = [{
    label: "Catalog Overview",
    url: ""
  }];
  catalogStatus = [
    {
      id: 1, name: "Active", clicked: false
    },
    {
      id: 2, name: "Inactive", clicked: false
    }
  ];
  fileList: NzUploadFile[] = [];
  migrateStart: boolean = false;
  importStart: boolean = false;
  deleteStart: boolean = false;
  currentSelectedFile: File | undefined;
  progress = 0;

  constructor(private apiService: ApiService, private router: Router, private app: AppComponent,
    public authService: AuthService, private messageService: NzMessageService
  ) { }

  ngOnInit(): void {
    this.dataLoaded = false;
    this.app.handleNavigate();
    this.handleTab(this.catalogStatus[0]);
    this.getAllCatalogs();
  }

  getAllCatalogs() {
    this.apiService.getCatalogData().subscribe(response => {
      response.sort((a: any, b: any) => a['catalogName'].localeCompare(b['catalogName']));
      this.originalCatalogDBData = response;
      this.filterCatalogList();
      this.dataLoaded = true;
    }, err => {
      this.dataLoaded = true;
      this.catalogData = [];
    })
  }

  getOldCatalogs() {
    this.apiService.getOldCatalogList().subscribe(response => {
      this.oldCatalogData = response;
    })
  }

  filterCatalogList() {
    this.toggleActiveList();
    this.catalogData = cloneDeep(this.originalCatalogData);
    this.displayCatalogData = this.groupItemsByFirstLetter(this.catalogData);
  }

  toggleActiveList() {
    let activeOption = this.activeTab == 'Active' ? 1 : 0;
    this.originalCatalogData = this.originalCatalogDBData.filter((item: any) =>
      item['activeFlag'] == activeOption);
  }

  trackByFn(index: number, item: any): any {
    return item.catalogId;
  }

  trackByMenu(index: number, menu: any): any {
    return menu.id;
  }

  trackByIndex(index: number, item: string): number {
    // Since strings are primitives, we can track by index
    return index;
  }

  handleTab(tab: any) {
    this.catalogStatus.map(node => {
      if (node.id == tab.id) {
        node.clicked = true;
        this.activeTab = node.name;
      }
      else {
        node.clicked = false;
      }
    })
  }

  close() {
    this.addCatalogVisible = false;
  }

  filterCatalog(searchTerm: any) {
  this.catalogData = this.originalCatalogData.filter((item: any) => {
  const nameMatch = item['catalogName']
    ?.toLowerCase()
    .includes(searchTerm.toLowerCase());

  const edpMatch = String(item['edpArNo'])
    ?.toLowerCase()
    .includes(searchTerm.toLowerCase());

  return nameMatch || edpMatch;
});
    this.displayCatalogData = this.groupItemsByFirstLetter(this.catalogData);
  }

  sortCatalog() {
    this.sortDirAsc = !this.sortDirAsc;
    if (this.sortDirAsc) {
      this.catalogData.sort((a: any, b: any) => a['catalogName'].localeCompare(b['catalogName']));
    } else {
      this.catalogData.sort((a: any, b: any) => b['catalogName'].localeCompare(a['catalogName']));
    }
    this.displayCatalogData = { ...this.groupItemsByFirstLetter(this.catalogData) };
  }

  groupItemsByFirstLetter(data: any) {
    let result = data.reduce((acc: any, item: any) => {
      const firstLetter = item['catalogName'][0].toUpperCase();
      acc[firstLetter] = acc[firstLetter] || [];
      acc[firstLetter].push(item);
      return acc;
    }, {});

    if (this.sortDirAsc) {
      this.groupedHeaderList = Object.keys(result).sort();
    } else {
      this.groupedHeaderList = Object.keys(result).sort().reverse();
    }
    return result;
  }

  redirect(category: any) {
    this.apiService.selectedCatalog = category?.catalogName;
  }

  enableMigrate(value: any) {
    return value == 0 ? true : false;
  }

  deActivateCatalog(catalog: any) {
     this.selectedCatalog = catalog['catalogName'];
    this.modalMessage = `Are you sure you want to deactivate <b>${this.selectedCatalog}</b> catalog?`;
    this.modalButton = 'Deactivate';
    this.showModal = true;
    this.selectedCatalogId = catalog['catalogId'];
  }

  publishCatalog(catalogId: any) {
    this.modalMessage = 'Publish will start displaying this catalog to the website users based on AR/EDP association.<br><br> Are you sure you want to continue?';
    this.modalButton = 'Publish';
    this.showModal = true;
    this.selectedCatalogId = catalogId;
  }

  onConfirmDeactivate() {
    this.apiService.deactivateCatalog(this.selectedCatalogId, 0).subscribe(response => {
      this.showModal = false;
      this.apiService.createNotification('success', 'Catalog deactivated successfully');
      this.selectedCatalog = '';
      this.getAllCatalogs();
    },
      err => {
        this.apiService.createNotification('error', err?.error?.message);
        this.showModal = false;
      })
  }

  undoDeactiveCatalog(catalogId: any) {
    this.apiService.deactivateCatalog(catalogId, 1).subscribe(response => {
      this.apiService.createNotification('success', 'Catalog activated successfully');
      this.getAllCatalogs();
    },
      err => {
        this.apiService.createNotification('error', err?.error?.message);
      })
  }

  deleteCatalog(catalog: any) {
    if (!this.authService.CCDelete)
      return;

    this.showDeleteModal = true;
    this.selectedCatalogId = catalog['catalogId'];
    this.selectedCatalog = catalog['catalogName'];
  }

  onConfirm(action: string) {

    if (action == 'Deactivate') {
      this.onConfirmDeactivate();
    }

    if (action == 'Publish') {
      this.onConfirmPublish()
    }

  }

  onConfirmDelete() {
    this.deleteStart = true;
    this.apiService.deleteCatalog(this.selectedCatalogId).subscribe(response => {
      this.deleteStart = false;
      this.showDeleteModal = false;
      this.apiService.createNotification('success', 'Catalog deleted successfully');
      this.selectedCatalog = '';
      this.getAllCatalogs();
    },
      err => {
        this.apiService.createNotification('error', err?.error?.message);
        this.deleteStart = true;
      })
  }

  exportCatalog(category: any) {
    if (!this.authService.CCAdd)
      return;

    this.apiService.exportCatalog(category['catalogId']).subscribe(response => {
      const jsonString = JSON.stringify(response, null, 2);
      this.saveJsonFile(jsonString, category['catalogName'])
      this.apiService.createNotification('success', 'Catalog exported successfully');
    },
      err => {
        this.apiService.createNotification('error', err?.error?.message);
      })
  }

  beforeUpload = (file: NzUploadFile): boolean => {
    const isJson = file.type === 'application/json' || file.name.endsWith('.json');
    if (!isJson) {
      return false;
    }
    return true; 
  };

  saveJsonFile(jsonString: string, filename: string): void {
    const blob = new Blob([jsonString], { type: 'application/json' });
    const a = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(objectUrl);
    document.body.removeChild(a);
  }

  onConfirmPublish() {
    this.apiService.publishCatalog(this.selectedCatalogId, 1).subscribe(response => {
      this.showModal = false;
      this.apiService.createNotification('success', 'Catalog published successfully');
      this.selectedCatalog = '';
      this.getAllCatalogs();
    },
      err => {
        this.apiService.createNotification('error', err?.error?.message);
        this.showModal = false;
      })
  }


  onConfirmImport() {
    if (!this.authService.CCAdd)
      return;

    this.importStart = true;
    this.apiService.importCatalog(this.currentSelectedFile).subscribe(response => {
      this.importStart = false;
      this.apiService.createNotification('success', 'Catalog Imported successfully');
      this.currentSelectedFile = undefined;
      this.fileList = [];
      this.getAllCatalogs();
      this.showImportModal = false;
    },
      err => {
        this.importStart = false;
        this.showImportModal = false;
        this.currentSelectedFile = undefined;
        this.fileList = [];
        this.apiService.createNotification('error', err?.error?.message);
      });
  }

handleChange({ file, fileList }: NzUploadChangeParam): void {

  if (fileList.length > 1) {
    fileList = fileList.slice(-1);
  }
  this.fileList = fileList;

  // 2. Safely grab the raw file object from the newest file
  const activeFile = this.fileList[0];
  if (activeFile) {
    this.currentSelectedFile = activeFile.originFileObj;
  } else {
    this.currentSelectedFile = undefined;
  }
}

  onConfirmMigrate() {
    if (!this.authService.CCAdd) return;

    this.migrateStart = true;

    this.apiService.migrateAsyncCatalog(this.selectedOldCatalogId).pipe(
      delay(10000),
      switchMap(() => timer(0, 5000).pipe(

        switchMap(() => this.apiService.catalogMigrateStatus(this.selectedOldCatalogId)),

        takeWhile(res =>
          res?.status !== 'COMPLETED' &&
          res?.status !== 'FAILED',
          true
        ),
        catchError(err => {
          console.error('Polling error', err);
          return of({ status: 'RETRYING' });
        })
      ))
    ).subscribe({
      next: (val) => {
      },
      error: (err) => {
        this.migrateStart = false;
        this.apiService.createNotification('error', err?.error?.message);
      },
      complete: () => {
        this.migrateStart = false;
        this.apiService.createNotification('success', 'Catalog migrated successfully');
        this.selectedOldCatalogId = '';
        this.getAllCatalogs();
        this.showMigrateModal = false;
      }
    });
  }
}

